module.exports = __webpack_public_path__ + "img/e_2_19_g.294e6f9e.png";